import { CONSTRUCTION_TYPE } from '@/constants/accessor/api/emergencyInspectionResult/assessmentInfo/constructionType'
import { ERROR_CODES } from '@/constants/error/errorCode'
import { calculationOverallResult } from '@/modules/calculationOverallResult/calculationOverallResult'
import { useInspectionResultStore } from '@/stores/inspectionResultUpsertStore'
import { GlobalError } from '@/utils/globalError/GlobalError'

/**
 * 判定結果算出ロジック実行
 * @param なし
 * @returns overallResult 総合判定結果値
 */
export const executeCalculationOverallResult = () => {
  const inspectionResultStore = useInspectionResultStore()

  const constructionType = inspectionResultStore.assessmentInfo.constructionType
  if (constructionType == null)
    throw new GlobalError([ERROR_CODES.STEP2_CONSTRUCTION_TYPE_UNSELECTED])

  const neighboringTypeMap = {
    [CONSTRUCTION_TYPE.WOOD]: inspectionResultStore.step2NeighboringWood,
    [CONSTRUCTION_TYPE.STEEL]: inspectionResultStore.step2NeighboringSteel,
    [CONSTRUCTION_TYPE.RC]: inspectionResultStore.step2NeighboringRc
  }
  const fallingTypeMap = {
    [CONSTRUCTION_TYPE.WOOD]: inspectionResultStore.step2FallingWood,
    [CONSTRUCTION_TYPE.STEEL]: inspectionResultStore.step2FallingSteel,
    [CONSTRUCTION_TYPE.RC]: inspectionResultStore.step2FallingRc
  }

  return calculationOverallResult(constructionType, inspectionResultStore.step1, {
    neighboring: neighboringTypeMap[constructionType],
    falling: fallingTypeMap[constructionType]
  })
}
